import { render, staticRenderFns } from "./OtherPartyCommon.vue?vue&type=template&id=71f17272&scoped=true"
import script from "./OtherPartyCommon.vue?vue&type=script&lang=ts"
export * from "./OtherPartyCommon.vue?vue&type=script&lang=ts"
import style0 from "./OtherPartyCommon.vue?vue&type=style&index=0&id=71f17272&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f17272",
  null
  
)

export default component.exports